import { DoctorDto } from "../../../../../Api/Model/DoctorDto.csharp";

export const doctorInitialState: DoctorDto = {
  id: "",
  name: "",
  firstName: "",
  jobTitle: "",
  specialization: "",
  bio: "",
  citation: "",
  areasOfExpertise: "",
  pictureUrl: "",
  pictureAlt: "",
  services: [],
  centers: [],
  relatedSpecializations: [],
  minimumAge: 0,
  minimumAgeAlert: "",
  sortIndex: 0,
  disableBooking: false,
  doctorUrl: "",
  isNotADoctor: false,
  ignoreMissingAppointmentsStatistics: false,
  keywords: []
};
